import { Component, Input } from "@angular/core";
import { IconType } from "../types/icons.types";

@Component({
  selector: "ds-icon",
  templateUrl: "./ds-icon.component.html",
  styleUrls: ["./ds-icon.component.scss"],
})
export class DsIconComponent {
  @Input() icon: string = "";
  @Input() width: string = "inherit";
  @Input() height: string = "inherit";
  @Input() type: IconType = "default";
  @Input() disabled: boolean = false;
  @Input() addBackground: boolean = false;

  constructor() {}
}
